import { Button, Typography } from "@mui/material";
import React from "react";

export const FilterButton = ({
	content = null,
	colorOption = null,
	widthOption = null,
	heigthOption = null,
}) => {
	return (
		<Button
			variant="contained"
			color="primary"
			// disableElevation
			sx={{
				// width: "3rem",
				// height: "3rem",
				width: `${widthOption}`,
				height: `${heigthOption}`,
				border: "1px solid rgb(201, 201, 201)",
				borderRadius: "50px",
				minWidth: "0",
			}}
			style={{ backgroundColor: `#${colorOption}` }}
		>
			<Typography variant="subtitle">{content}</Typography>
		</Button>
	);
};
